import { render } from "./ProjectLangEditorRolePage.vue?vue&type=template&id=3b2c72c2&scoped=true"
import script from "./ProjectLangEditorRolePage.vue?vue&type=script&lang=js"
export * from "./ProjectLangEditorRolePage.vue?vue&type=script&lang=js"

import "./ProjectLangEditorRolePage.vue?vue&type=style&index=0&id=3b2c72c2&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-3b2c72c2"

export default script